module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-en-2.18bda109.png";